import { DayOfWeek } from '@/externals/gyym'
import { DayOfWeekOption } from './types'
import { TimeSlot } from '@/externals/gyym/user/kartes'

export const dayOfWeekOptions: DayOfWeekOption[] = [
  {
    label: '月曜日',
    value: DayOfWeek.MONDAY,
  },
  {
    label: '火曜日',
    value: DayOfWeek.TUESDAY,
  },
  {
    label: '水曜日',
    value: DayOfWeek.WEDNESDAY,
  },
  {
    label: '木曜日',
    value: DayOfWeek.THURSDAY,
  },
  {
    label: '金曜日',
    value: DayOfWeek.FRIDAY,
  },
  {
    label: '土曜日',
    value: DayOfWeek.SATURDAY,
  },
  {
    label: '日曜日',
    value: DayOfWeek.SUNDAY,
  },
]

export const defaultTimeSlots: TimeSlot[] = [
  {
    dayOfWeeks: [
      DayOfWeek.MONDAY,
      DayOfWeek.TUESDAY,
      DayOfWeek.WEDNESDAY,
      DayOfWeek.THURSDAY,
      DayOfWeek.FRIDAY,
    ],
    startTimeFrom: '06:00',
    startTimeTo: '09:00',
  },
  {
    dayOfWeeks: [DayOfWeek.SATURDAY, DayOfWeek.SUNDAY],
    startTimeFrom: '06:00',
    startTimeTo: '09:00',
  },
]
